import { useDebounceFn, useOffsetPagination } from '@vueuse/core'

export default async function usePaginatedFilteredQuery (total: Ref<number>, pageSize: number, fetchData, filterQuery) {
  const {
    currentPage,
    pageCount,
    isFirstPage,
    isLastPage,
    prev,
    next
  } = useOffsetPagination({
    total,
    page: 1,
    pageSize,
    onPageChange,
    onPageSizeChange: fetchData
  })

  const appConfig = useAppConfig()

  const offset = computed(() => (currentPage.value - 1) * pageSize)

  const fetchDataDebounced = useDebounceFn(async () => {
    await fetchData()
    currentPage.value = 1
  }, appConfig.filterDebounceDuration)

  watch(filterQuery, fetchDataDebounced)

  function onPageSelect (value: number): void {
    currentPage.value = value
  }

  async function onPageChange () {
    await fetchData()
    window.scrollTo(0, 0)
  }

  return {
    currentPage,
    pageCount,
    isFirstPage,
    isLastPage,
    prev,
    next,
    offset,
    onPageSelect
  }
}
